import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import MechanicsCalendar from "../components/MechanicsCalendar/MechanicsCalendar";
import getApiBase from "../components/getApiBase";

/**
 * TASK-543 — iframe-friendly embed (`/calendar/embed?shopId=`).
 * Same-origin session cookie auth (no postMessage parent bridge yet).
 */
export default function CalendarEmbed() {
  const [params] = useSearchParams();
  const shopIdParam = Number(params.get("shopId"));
  const [shopId, setShopId] = useState(shopIdParam || null);
  const [isOwner, setIsOwner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(`${getApiBase()}/api/mechanicDashboard/shops`, {
          credentials: "include",
        });
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.error || data.message || "Not signed in");
        }
        const shops = data.shops || [];
        const match = shopIdParam
          ? shops.find((s) => Number(s.id) === shopIdParam)
          : shops.find((s) => s.is_primary) || shops[0];
        if (!match?.id) {
          throw new Error(
            shopIdParam
              ? "You do not have access to this shop calendar."
              : "Missing shopId and no primary shop on this account.",
          );
        }
        setShopId(match.id);
        setIsOwner(match.role === "Owner");
      } catch (err) {
        setError(err.message || "Failed to load embed calendar");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [shopIdParam]);

  return (
    <Box sx={{ p: 1, bgcolor: "#f7f9fc", minHeight: "100vh" }}>
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} />
        </Box>
      )}
      {!loading && error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
      {!loading && !error && shopId && (
        <MechanicsCalendar shopId={shopId} isOwner={isOwner} compact />
      )}
    </Box>
  );
}
